/**
 * pixi-particles — zones/DeathZone.ts
 * Ported from Phaser.GameObjects.Particles.Zones.DeathZone
 */
import { IZoneSource } from './Shapes';
import { AnyParticle } from '../EmitterOp';

export class DeathZone
{
    constructor (public source: IZoneSource, public killOnEnter: boolean) {}

    willKill (particle: AnyParticle): boolean
    {
        var pos = particle.worldPosition || particle;
        var contains = this.source.contains!(pos.x, pos.y);

        return (contains && this.killOnEnter) || (!contains && !this.killOnEnter);
    }
}

export default DeathZone;
